import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Select } from 'antd'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import TotalAndBar from '@/pages/Bmjy/components/components/TotalAndBar'

const tabsOptions = [
  {
    label: '按公司', 
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

const gsTypeFilterOptions = [
  {
    label: '项目', 
    value: '项目',
  }, 
  {
    label: '非项目', 
    value: '非项目',
  }, 
  {
    label: '项目预收', 
    value: '项目预收',
  }, 
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [data1, setData1] = useState([])
  const [data2, setData2] = useState([])
  const [tabType, setTabType] = useState('')
  const [gsType, setGsType] = useState([])
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const mockData = useCallback(() => {
    const d1 = []
    const d2 = []
    for(let i=0; i<12; i++) {
      d1.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
      d2.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
    }
    setData1(d1)
    setData2(d2)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    mockData()
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
    }
  }, [mockData])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    setTabType(value.tab)
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='月度统计'
        hasDepartSelect
        customFilter={
          tabType === 'ags' && <div className='ml-10'>
            <Select allowClear placeholder="请选择" maxTagCount={1} value={gsType} onChange={setGsType} size='small' mode="multiple" style={{minWidth: '100px'}}>
              {
                gsTypeFilterOptions.map(r => <Select.Option value={r.value} key={r.value}>{r.label}</Select.Option>)
              }
            </Select>
          </div>
        }
      >
        <TotalAndBar
          barData1={data1}
          barLabel1='本年'
          barData2={data2}
          barLabel2='上年'
          totalItems={[
            {label: '本年到款合计（万）', value: '549,262.16', primary: true},
            {label: '上年到款合计（万）', value: '876,623.98'},
            {label: '累计未分配合计（万）', value: '149,262.16'},
          ]}
        />
      </CardContainer>
    </Spin>
  )
}

export default Component
